export const faqs = {
    state: {
        faqs: [
            {
                title: '',
                questions: []
            }
        ]
    },
    mutations: {
        SET_FAQ_SNIPPETS(state, payload) {
            const snippetContent = []
            payload.snippetContentResponseList.forEach(el => {
                const snippetData = JSON.parse(
                    el.content.replace(/(\r\n|\n|\r)/gm, '')
                )
                snippetContent.push({
                    title: '',
                    questions: snippetData
                })
            })
            state.faqs = snippetContent
        }
    },
    getters: {
        getFaqs: state => state.faqs
    }
}
